import classNames from 'classnames';

export default function Image({ image, isNew, newType }) {
  return (
    image && (
      <div className={'button__icon button_transparent custom-button__icon'}>
        <img src={image} alt={''} />
        {isNew && <span className={classNames('button__circle', { [`button__circle_${newType}`]: newType })} />}
      </div>
    )
  );
}
